import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { DropdownList } from "react-widgets/cjs";
import { ReactComponent as ArrowDown } from "../../../../assets/elevva-pro-icons/arrowDown.svg";
import { useState } from "react";

const Step7 = ({ userDetail, setFormData }) => {
  const [selectedTime, setSelectedTime] = useState(null);
  const listBookinTime = userDetail?.observations || [];

  // const listBookinTime = [
  //   {
  //     id: 60,
  //     name: "22/03/2025",
  //     value:
  //       "El entrenamiento constante, combinado con una buena alimentación y descanso adecuado, mejora el rendimiento físico y mental en cualquier disciplina deportiva.",
  //   },
  //   {
  //     id: 180,
  //     name: "22/03/2025",
  //     value:
  //       "El entrenamiento constante, combinado con una buena alimentación y descanso adecuado, mejora el rendimiento físico y mental en cualquier disciplina deportiva.",
  //   },
  //   {
  //     id: 360,
  //     name: "10/03/2025",
  //     value:
  //       "El entrenamiento constante, combinado con una buena alimentación y descanso adecuado, mejora el rendimiento físico y mental en cualquier disciplina deportiva.",
  //   },
  //   {
  //     id: 540,
  //     name: "15/03/2025",
  //     value:
  //       "El entrenamiento constante, combinado con una buena alimentación y descanso adecuado, mejora el rendimiento físico y mental en cualquier disciplina deportiva.",
  //   },
  //   {
  //     id: 720,
  //     name: "22/06/2025",
  //     value:
  //       "El entrenamiento constante, combinado con una buena alimentación y descanso adecuado, mejora el rendimiento físico y mental en cualquier disciplina deportiva.",
  //   },
  //   {
  //     id: 900,
  //     name: "31/06/2025",
  //     value:
  //       "El entrenamiento constante, combinado con una buena alimentación y descanso adecuado, mejora el rendimiento físico y mental en cualquier disciplina deportiva.",
  //   },
  //   {
  //     id: 1080,
  //     name: "22/06/2025",
  //     value:
  //       "El entrenamiento constante, combinado con una buena alimentación y descanso adecuado, mejora el rendimiento físico y mental en cualquier disciplina deportiva.",
  //   },

  //   ,
  // ];

  return (
    <div className="d-flex flex-column col-3 px-2 h-100 w-100">
      <div className="d-flex justify-content-start">
        <span className="label-step">
          <strong>7. Observaciones de control</strong>
        </span>
      </div>

      <div className="pt-2 d-flex flex-column gap-2" style={{ height: "94%" }}>
        <div className="d-flex justify-content-center gap-3 align-items-center py-1">
          <div className="d-flex  w-100 " id="location-select">
            <DropdownList
              style={{ width: "80%" }}
              busy
              busySpinner={<ArrowDown></ArrowDown>}
              className={
                "input-style-elevva-graphics mx-auto input_info_athlete_input"
              }
              id="optionSummary"
              placeholder={"Buscar control"}
              //   defaultValue={
              //     listBookinTime
              //       .filter((e) => e.id == availability?.max_booking_time)
              //       .map((memb) => ({
              //         id: memb.id,
              //         name: memb.name,
              //         value: memb.id,
              //       }))[0]
              //   }
              data={listBookinTime.map((memb) => ({
                id: memb.id,
                name: memb.date,
                value: memb.date,
              }))}
              dataKey="id"
              textField="name"
              onChange={(value) => setSelectedTime(value.id)}
              renderListItem={({ item }) => (
                <div
                  className="w-100 mb-1"
                  style={{ borderBottom: "1px solid #9DACBD" }}
                >
                  <div>{item.name}</div>
                </div>
              )}
            />
          </div>
        </div>
        {/* Parte 2: Prueba de recuperación */}
        <div className="step3-card py-1 px-4 flex-grow-1 d-flex flex-column justify-content-center align-items-center">
          <PerfectScrollbar className="w-100 d-flex flex-column justify-content-center align-items-center">
            {selectedTime ? (
              <div
                className="input_info_athlete d-flex flex-column gap-2 w-100 pb-2"
                style={{ borderBottom: "1px solid #9DACBD" }}
              >
                <span>
                  {listBookinTime.find((item) => item.id == selectedTime)?.date}
                </span>
                <span>
                  {
                    listBookinTime.find((item) => item.id == selectedTime)
                      ?.description
                  }
                </span>
              </div>
            ) : listBookinTime.length > 0 ? (
              listBookinTime.map((item) => (
                <div
                  className="input_info_athlete d-flex flex-column gap-2 w-100 pb-2"
                  style={{ borderBottom: "1px solid #9DACBD" }}
                >
                  <span>{item.date}</span>
                  <span>{item.description}</span>
                </div>
              ))
            ) : (
              <div>
                <span
                  className="input_info_athlete"
                  style={{ fontSize: "calc(.4rem + .3vw)" }}
                >
                  No hay observaciones
                </span>
              </div>
            )}
          </PerfectScrollbar>
        </div>
      </div>
    </div>
  );
};

export default Step7;
